<template>
  <div>
    <div class="grid-content maintitle">
      <span>资源位</span>
    </div>

    <div class="grid-content content-margin">
      <div class="buttonarea">
        <el-link :underline="false">
          <el-button size="medium" round @click.native="refresh">
            <i class="iconfont">&#xe667;</i>
            {{ $t("message.刷新") }}
          </el-button>
        </el-link>
        <el-link :underline="false">
          <el-button size="medium" round @click.native="downloadCsv">
            <i class="iconfont">&#xe667;</i>
            {{ $t("message.导出") }}
          </el-button>
        </el-link>
      </div>
    </div>

      <!-- 筛选栏开始 -->
      <div class="grid-content content-margin search-style">
      <table class="simpleRow">
        <tr>
          <td>
            <span class="simpleLabel">场景</span>
          </td>
          <td>
            <el-select v-model="filterBody.scene" clearable size="small">
              <el-option v-for="item in sceneOptions" :key="item.value" :label="item.name" :value="item.value">
              </el-option>
            </el-select>
          </td>
          <td style="padding-left: 20px">
            <span class="simpleLabel">ID</span>
          </td>
          <td>
            <el-input clearable prefix-icon="el-icon-search" v-model="filterBody.id" size="small" 
              placeholder="输入标题" />
          </td>

          <td style="padding-left: 20px">
            <span class="simpleLabel">开始日期</span>
          </td>
          <td>
            <el-date-picker v-model="filterBody.date.fromdate" type="date" placeholder="选择日期">
            </el-date-picker>
          </td>

          <td style="padding-left: 20px">
            <span class="simpleLabel">结束日期</span>
          </td>
          <td>
            <el-date-picker v-model="filterBody.date.todate" type="date" placeholder="选择日期">
            </el-date-picker>
          </td>

          <!-- <td style="padding-left: 20px">
            <el-button type="primary" size="mini" style="float: right" @click="refresh">检索</el-button>
          </td> -->
        </tr>
      </table>
        <!-- 筛选按钮开始 -->
        <div class="search-button"> 
            <div style="flex:0 0 80px;text-align:right"> </div>
            <div style="display:flex;">
              <el-button type="primary" @click="refresh" style="width:49%;box-sizing:border-box;border-radius: 14px;" class="br" size="mini" icon="el-icon-search">检索</el-button>
              <el-button type="danger"  @click="clear" style="width:49%;box-sizing:border-box;border-radius: 14px;" class="br" size="mini"  icon="el-icon-delete">清除</el-button>
            </div>
        </div>
            <!-- 筛选按钮结束 -->
      </div>
      <!-- 筛选栏结束 -->

    <div class="grid-content content-margin">
      <el-table ref="table" :data="clickList" stripe border :height="tableHeight" style="width: 100%">
        <el-table-column prop="scene" label="场景">
        </el-table-column>

        <el-table-column prop="id" label="ID">
        </el-table-column>

        <el-table-column prop="source" label="资源">
          <template slot-scope="scope">
            <el-popover v-if="scope.row.scene == '轮播Banner'" placement="top-start" title="" trigger="hover">
              <img :src="'' + scope.row.source" alt="" style="max-width: 500px; max-height: 500px">
              <img slot="reference" :src="'' + scope.row.source" style="max-width: 120px; max-height: 30px">
            </el-popover>
            <span v-else>{{scope.row.source}}</span>
          </template>
        </el-table-column>

        <el-table-column prop="pv" label="日均访问次数" width="125">
        </el-table-column>

        <el-table-column prop="uv" label="日均访问人数" width="125">
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <pagination :pagesizeList="pageConfig.pagesizeList" :pagesize="pagingBody.pageConfig.pagesize"
        :total="pageConfig.total" :page="pagingBody.pageConfig.page"></pagination>
    </div>

    <a :href="url" style="display: none" ref="aclick"></a>
  </div>
</template>

<script>
// 分页模块
import pagination from "@/components/pagination/pagination";
import { rejecthttp, changeflagCLOSED } from "@/utils/request";

export default {
  name: "ClickDimension",
  components: {
    pagination,
  },
  data() {
    return {
      sceneOptions: [
        { value: "home_banner", name: "轮播Banner" },
        { value: "home_notification", name: "小喇叭滚动通知" },
        { value: "home_menu", name: "八宫格菜单栏，二级菜单" },
        { value: "home_live", name: "官方直播" },
        { value: "home_college", name: "卖家大学" },
        { value: "home_pop", name: "弹窗" },
        { value: "home_ball", name: "悬浮球" },
        { value: "home_go", name: "Walmart Go" },
      ],

      //检索数据
      filterBody: {},

      tableHeight: 500,

      //获取列表
      clickList: [],

      // 分页
      pageConfig: {
        pagesizeList: [20, 50, 100],
        total: null,
      },

      pagingBody: {
        appID: 188,
        filterConfig: {},
        pageConfig: {
          page: 1,
          pagesize: 20,
          pageStartIndex: 0,
        },
        sortConfig: {},
      },

      url: '',

      sendData: {
        appID: 188,
        filterConfig: {
          scene: "",
          id: null,
          date: { fromdate: null, todate: null},
        },
        pageConfig: {
          page: 1,
          pagesize: 20,
          pageStartIndex: 0,
        },
        sortConfig: {
          order: "",
          prop: "",
        },
      },
    };
  },
  mounted: function () {
    this.$nextTick(function () {
      if (this.$refs.table.$el !== "undefined")
        this.tableHeight =
          window.innerHeight - this.$refs.table.$el.offsetTop - 195;

      // 监听窗口大小变化
      let self = this;
      window.onresize = function () {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 195;
      };
    });
    //this.$refs.table.$el.offsetTop：表格距离浏览器的高度 //50表示你想要调整的表格距离底部的高度（你可以自己随意调整），因为我们一般都有放分页组件的，所以需要给它留一个高度
  },
  watch: {},
  methods: {
    clear(){
        this.filterBody.id='',
        this.sendData.filterConfig.id=''
        this.refresh()
      },
    paginationChange(pagesize, page, name) {
      this.pagingBody.pageConfig.page =
        page != -1 ? page : this.pagingBody.pageConfig.page;
      this.pagingBody.pageConfig.pagesize =
        pagesize != -1 ? pagesize : this.pagingBody.pageConfig.pagesize;
      this.refresh();
    },

    downloadCsv() {
      this.pagingBody.filterConfig = JSON.parse(
        JSON.stringify(this.filterBody)
      );

      rejecthttp(
        true,
        "post",
        "/manage/user/exportclickdimension",
        this.pagingBody,
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            this.url = "/rs/exportdownload/bigcsv?handlekey=" + doc.data.data;
            console.log("aaaaaaaaa", this.url);
            this.openCsv(this.url);
          }
        }
      );
    },

    openCsv(url) {
      this.$confirm("文件导出完成", "提示", {
        confirmButtonText: "下载",
        cancelButtonText: "取消",

        type: "info",
      })
        .then(() => {
          this.$refs.aclick.click();
          this.$message({
            type: "success",
            message: "正在下载!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消下载",
          });
        });
    },

    resetFilterBody() {
      this.filterBody = {
        scene: "",
        id: "",
        date: { fromdate: null, todate: null},
      };
    },

    refresh() {
      this.pagingBody.filterConfig = JSON.parse(
        JSON.stringify(this.filterBody)
      );
      rejecthttp(
        true,
        "post",
        "/manage/user/clickdimension",
        this.pagingBody,
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            console.log(doc.data);

            this.pageConfig.total = doc.data.exData.datas;
            this.clickList = doc.data.data;
          }
        }
      );
    },
  },
  created() {
    this.resetFilterBody();
    this.refresh();
  },
  computed: {},
};
</script>

<style scoped>
.el-table /deep/ td {
  user-select: text !important;
}

.serachSpan {
  width: 7%;
}

.serachText {
  width: 13%;
}

.serachInput {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/vipcenter/ClickDimension.vue